/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Badge, ButtonGroup, Card, Container } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "../../components";
import { GetSportsDetails } from "../../utilities/api/sports/indext";
import { ArchiveSport } from "./ArchiveSport";
import { ToastContainer, toast } from "react-toastify";
import { images } from "../../config/images";
import { SportDetail } from "../../utilities/types";




const SportInfo = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const [archive, setArchive] = useState(false);
  const [sportDetais, setSportsDetails] = useState<SportDetail>()

  const GetInfo = async () => {
    const result = await GetSportsDetails(location.state)
    if (result.statusCode === 200) {
      setSportsDetails(result.data)
    } else {
      toast.error(result.response.data.message);
    }
  }
  useEffect(() => {
    GetInfo()
  }, [])
  const handleEdit = (id: string) => {
    navigate("/update-sport", { state: sportDetais?.id })
  }
  return (
    <Container fluid className="g-0">
      <Card>
        <Card.Body>
          <div className="page-title align-items-center d-flex justify-content-between">
            <Card.Title className="mb-0">Sports Details</Card.Title>
            <ButtonGroup>
              <Button
                onClick={() => setArchive(true)}
                type="button"
                bname="Delete Sport"
                name="delete-sports"
                id="delete-sports"
                className="btn btn-light rounded-1 me-3"
              ></Button>
              <Button
                onClick={handleEdit}
                type="button"
                bname="Edit Sport"
                name="edit-sports"
                id="edit-sports"
                className="btn btn-primary rounded-1"
              ></Button>
            </ButtonGroup>
          </div>
          <h4 className="card-title2 text-start fs-2 fw-semibold d-flex align-items-center">
            {sportDetais?.name}
            <span className="badges ms-2 rounded-pill text-success badges-success">
              {sportDetais?.isActive ? "Active" : "InActive"}
            </span>
          </h4>
          <hr />
          <div className="d-flex pt-3">
            <div className="user-img">
              <img
                src={
                  sportDetais?.image
                    ? sportDetais.image
                    : images.imgupload.default
                }
                width="78"
                alt=""
                height="78"
                className="rounded-1"
              />
            </div>
          </div>

          {
            sportDetais?.sportRules.map((item: any, index) => {
              return (
                <Card key={"sport-rule" + index + 1} className="shadow-sm text-start sports-card">
                  <Card.Body>
                    <Badge bg="primary" pill className="rule-badges">
                      Rule {index + 1}
                    </Badge>
                    <h3 className="sports-text">
                      Subject:{' '}
                      <span className="text-info">{item.rule.subject}</span>
                    </h3>

                  </Card.Body>
                </Card>
              )
            })
          }
        </Card.Body>
      </Card>
      <ArchiveSport setArchive={setArchive} archive={archive} id={sportDetais?.id} />
      <ToastContainer />
    </Container>
  );
};

export { SportInfo };
